<template>
  <div>
    <a-divider class="color-orange" orientation="center" style="font-size: 20px">专家品目替换
    </a-divider>
    <s-table
        ref="table"
        :columns="columns"
        :data="loadData"
        :rowKey="record => record.id"
        :pagination="{ showTotal: (total) => `共 ${total} 条` }"
    >
      <template slot="name" slot-scope="record">
        <div>{{ record.expertName }}<br>{{ record.idCard }}</div>
      </template>
      <template slot="action" slot-scope="record">
        <a-button @click="openItem(record)" :loading="butLoading" type="primary">选择</a-button>
      </template>
    </s-table>
    <replace-purchase-item ref="replaceItemRef" :visible="replaceItemVisible" @cancel="replaceItemVisible = false" @success="afterSuccess"/>
  </div>
</template>

<script>
import STable from '@/components/Table'
import { QueryExpertInfo } from '@/epp/expertmain/expertInfo/api/ExpertInfoApi'
import ReplacePurchaseItem from '@/epp/expertmain/expertInfo/replace/ReplacePurchaseItem.vue'

const columns = [
  {
    title: '姓名',
    align: 'left',
    width: '250px',
    scopedSlots: { customRender: 'name' }
  },
  {
    title: '单位全称',
    width: '250px',
    dataIndex: 'unitName'
  },
  {
    title: '剩余旧采购品目',
    align: 'left',
    width: '30%',
    dataIndex: 'oldPurchaseItem'
  },
  {
    title: '新采购品目',
    align: 'left',
    width: '30%',
    dataIndex: 'purchaseItem'
  },
  {
    title: '操作',
    align: 'center',
    scopedSlots: { customRender: 'action' }
  },
]

export default {
  name: 'ExpertItemReplaceIndex',
  components: {
    STable,
    ReplacePurchaseItem
  },
  data () {
    return {
      columns,
      replaceItemVisible: false,
      butLoading: false,
      loadData: async parameter => {
        const params = { ...parameter, replaceFlag: 1 }
        return QueryExpertInfo(params)
      }
    }
  },
  created () {
  },
  methods: {
    //替换后刷新
    afterSuccess () {
      this.replaceItemVisible = false
      this.$refs.table.refresh()
    },
    //打开替换的品目列表
    openItem (record) {
      let fidArr = []
      let itemArr = []
      let codeArr = []
      let result = []
      if (record.purchaseItemId) {
        fidArr = record.purchaseItemId.split(',')
        itemArr = record.purchaseItem.split(',')
        codeArr = record.purchaseItemCode.split(',')
        for (let i = 0; i < fidArr.length; i++) {
          const data = {}
          data['fid'] = fidArr[i]
          data['fspmmc'] = itemArr[i]
          data['fspmbm'] = codeArr[i]
          result.push(data)
        }
      }
      this.$refs.replaceItemRef.preView(result,record.oldPurchaseItem,record.id)
      this.replaceItemVisible = true
    }
  }
}
</script>

<style lang="less" scoped>

</style>
